type Conditional = {
  [key: string]: boolean
}

type ConditionalOrString = Conditional | string

export const classnames = (
  ...args: (ConditionalOrString | null | undefined | false | 0 | '')[]
): string =>
  args
    .filter((arg) => {
      if (
        arg === null ||
        arg === undefined ||
        arg === false ||
        arg === 0 ||
        arg === ''
      ) {
        return false
      }
      return true
    })
    .reduce<string>((className, conditionalOrString) => {
      if (typeof conditionalOrString === 'string') {
        return className
          ? `${className} ${conditionalOrString}`
          : conditionalOrString
      }

      if (conditionalOrString && typeof conditionalOrString === 'object') {
        const conditionalClasses = Object.keys(conditionalOrString)
          .filter((key) => conditionalOrString[key])
          .join(' ')

        return className
          ? `${className} ${conditionalClasses}`
          : conditionalClasses
      }

      return className
    }, '')
    .trim()
